import { render, staticRenderFns } from "./LgtsAsset.vue?vue&type=template&id=d82229be"
import script from "./LgtsAsset.vue?vue&type=script&lang=js"
export * from "./LgtsAsset.vue?vue&type=script&lang=js"
import style0 from "./LgtsAsset.vue?vue&type=style&index=0&id=d82229be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports